import React from 'react';
import Circle from '@spectrum-icons/workflow/Circle';
import LoupeView from '@spectrum-icons/workflow/LoupeView';
import { Button } from 'app/views/components/editor/sidebar/Button';
export const PrimitiveShapePicker = (props) => {
    const { onChange } = props;
    const onSelectEllipse = React.useCallback(() => {
        onChange('ellipse');
    }, [onChange]);
    const onSelectRect = React.useCallback(() => {
        onChange('rect');
    }, [onChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { "data-test-id": "spot-ellipse", label: "Ellipse", Icon: Circle, onPress: onSelectEllipse }),
        React.createElement(Button, { "data-test-id": "spot-rect", label: "Rect", Icon: LoupeView, onPress: onSelectRect })));
};
